"use client";

import { memo } from "react";
import { ButtonGroup } from "@/components/ui/button-group";
import { Input } from "@/components/ui/input";
import type { Contributor, RiskLevel } from "@/types/endpoints/reports/GetAiReportById";
import { riskColors } from "../primitives/RiskIndicator";

interface ContributorsListProps {
  contributors: Contributor[];
  riskLevel: RiskLevel;
  getActionTypeName: (type: string) => string;
}

const ContributorsList = memo(function ContributorsList({
  contributors,
  riskLevel,
  getActionTypeName,
}: ContributorsListProps) {
  const baseColor = riskColors[riskLevel];

  if (!contributors || contributors.length === 0) {
    return null;
  }

  const sortedContributors = [...contributors].sort(
    (a, b) => (b.count ?? 0) - (a.count ?? 0),
  );

  return (
    <div className="flex flex-col gap-2 flex-1 overflow-y-auto">
      {sortedContributors.map((c) => (
        <div
          className="flex items-center gap-2"
          key={c.action_type}
        >
          <ButtonGroup className="h-9 grid grid-cols-[36px_1fr] w-full">
            <Input
              style={{
                backgroundColor: baseColor,
                fontFamily: "var(--font-monda)",
              }}
              readOnly
              value={c.count}
              className="text-center text-white text-xs px-0.5 py-0 h-9 tabular-nums focus-visible:ring-0 focus-visible:ring-offset-0 border-0"
            />
            <Input
              readOnly
              className="text-start bg-gray-100 text-xs px-1 py-0 h-9 tabular-nums focus-visible:ring-0 focus-visible:ring-offset-0 border-0"
              value={getActionTypeName(c.action_type)}
            />
          </ButtonGroup>
        </div>
      ))}
    </div>
  );
});

export default ContributorsList;